import { useContext } from "react";
import { useQuery } from "react-query";
import { toast } from "sonner";
import { FeatureAccessContext } from "@/context/featureAccess";
import { QuackChatSystemMessageType } from "@/v2/entities/quackchat/Quackchat.model";
import { useQuackchatApi } from "@/v2/entities/quackchat/Quackchat.api";

export function useGetQuackChatSystemMessage(
  type: QuackChatSystemMessageType = "WELCOME",
  simulatorId?: string
) {
  const { getSystemMessage } = useQuackchatApi();
  const { selectedWorkspace } = useContext(FeatureAccessContext);

  return useQuery({
    queryKey: ["quackchat-system-message", type, selectedWorkspace],
    queryFn: () =>
      getSystemMessage({
        type,
        tenant: selectedWorkspace,
        simulatorId,
      }),
    onSettled: (data, error) => {
      if (error != null) {
        toast.error("Failed to fetch system message");
      }

      if (data?.message == null) {
        toast.error("System message is disabled");
      }
    },
  });
}
